module.exports = __webpack_public_path__ + "static/media/template-ilustrativo.231e717a.png";